Ext.ns('mx.comp');

mx.comp.GroupingView = Ext.extend(Ext.grid.GroupingView, {
    forceFit: true,
    enableGroupingMenu: false,
    enableNoGroups: false,
    hideGroupedColumn: true,
    groupHdCls: 'groupHdCls',

    interceptMouse: function(e) {
        var hd = e.getTarget('.' + this.groupHdCls, this.mainBody);
        if (!hd) {
            mx.comp.GroupingView.superclass.interceptMouse.apply(this, arguments);
        }
    },
    // id for testers:
    gridHeaderId: 'gridHeaderId',
    gridBodyId: 'gridBodyId',
    initTemplates: function() {
        mx.comp.GroupingView.superclass.initTemplates.call(this);
        this.templates.header = new Ext.Template(
            '<table border="0" cellspacing="0" cellpadding="0" style="{tstyle}" id="' + this.gridHeaderId + '">',
            '<thead><tr class="x-grid3-hd-row">{cells}</tr></thead>',
            '</table>'
        );
        this.templates.master = new Ext.Template(
            '<div class="x-grid3" hidefocus="true">',
            '<div class="x-grid3-viewport">',
            '<div class="x-grid3-header"><div class="x-grid3-header-inner"><div class="x-grid3-header-offset">{header}</div></div><div class="x-clear"></div></div>',
            '<div class="x-grid3-scroller"><div class="x-grid3-body" id="' +
                this.gridBodyId +
                '">{body}</div><a href="#" class="x-grid3-focus" tabIndex="-1"></a></div>',
            '</div>',
            '<div class="x-grid3-resize-marker">&#160;</div>',
            '<div class="x-grid3-resize-proxy">&#160;</div>',
            '</div>'
        );
    },
});
